class CameraService {
    constructor() {
      this.videoRef = null;
    }
  
    setVideoElement(videoElement) {
      this.videoRef = videoElement;
    }
  
    async startCamera() {
      if (this.videoRef) {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ video: true });
          this.videoRef.srcObject = stream;
        } catch (err) {
          console.error('Error accessing camera: ', err);
        }
      } else {
        console.warn('No video element provided.');
      }
    }
  
    stopCamera() {
      if (this.videoRef && this.videoRef.srcObject) {
        const stream = this.videoRef.srcObject;
        const tracks = stream.getTracks();
  
        tracks.forEach((track) => track.stop());
  
        this.videoRef.srcObject = null;
       
      } else {
        console.warn('No active camera to stop.');
      }
    }
  }
  
  const cameraService = new CameraService();
  export default cameraService;
  